// @flow

// Libs
import _find from 'lodash/find'
import { createSelector } from 'reselect'

import { users$ } from 'fc-users'

export default createSelector(
  [ users$ ],
  (users: UsersById): Array<User> => {
    const user = _find(users, (user: User): Array<User> => user.clientBillingAddress)
    return user && user.clientBillingAddress
  }
)
